<template>
    <div v-click-outside:callback="closeEvent" class="single-element-container">
       <b-btn @click="showCollapse = !showCollapse" :class="showCollapse ? 'collapsed' : null" class="btn btn-secondarys btn-color-picker dropdown-toggle" :aria-controls="colorPickerId" :aria-expanded="showCollapse ? 'true' : 'false'" :size="size"><span class="color-picker-box" v-bind:style="colorStyle"></span></b-btn>
       <b-collapse v-model="showCollapse" :id="colorPickerId" class="fill-color-picker">
            <sketch v-model="color" v-on:input="updateValue()"/>
       </b-collapse>
    </div>
</template>

<script>
import { Sketch } from "vue-color";
import ClickOutside from "../directives/ClickOutside.vue";
import { hexToRgb } from "../api/HelperFunctions";

export default {
  name: "ColorPicker",
  props: ["value", "size"],
  data() {
    return {
      id: "",
      colorPickerId: "",
      showCollapse: false,
      color: { r: 0, g: 0, b: 0, a: 1 },
      fromChild: false
    };
  },
  computed: {
    colorStyle: function() {
      let rgba = this.color.r != null ? this.color : this.color.rgba;
      return {
        "background-color":
          "rgba(" + rgba.r + "," + rgba.g + "," + rgba.b + "," + rgba.a + ")"
      };
    }
  },
  mounted() {
    this.id = this._uid;
    this.colorPickerId = "color-picker-" + this.id;
    if (typeof this.value === "string" && this.value.indexOf("#") === 0) {
      this.color = hexToRgb(this.value);
    } else {
      this.color = this.value;
    }
  },
  methods: {
    updateValue() {
      let rgba = this.color.r != undefined ? this.color : this.color.rgba;
      this.fromChild = true;
      this.$emit("input", rgba);
    },
    closeEvent: function() {
      if (this.showCollapse) {
        this.showCollapse = false;
      }
    }
  },
  watch: {
    value: function(newValue, oldValue) {
      if (!this.fromChild && (newValue.r != oldValue.r || newValue.g != oldValue.g || newValue.b != oldValue.b || newValue.a != oldValue.a)) {
        if (typeof newValue === "string" && newValue.indexOf("#") === 0) {
          this.color = hexToRgb(newValue);
        } else {
          this.color = newValue;
        }
      } else {
        this.fromChild = false;
      }
    }
  },
  components: {
    Sketch
  },
  directives: {
    ClickOutside
  }
};
</script>
<style>
.btn-color-picker span.color-picker-box {
  display: inline-block;
  width: 24px;
  height: 24px;
  margin-bottom: -6px;
  border: 1px solid white;
}
.btn-color-picker.btn-sm span.color-picker-box {
  width: 18px;
  height: 18px;
  margin-bottom: -3px;
}
.fill-color-picker {
  position: absolute;
  z-index: 999;
}
.vc-chrome {
  border: 1px solid #ccc;
  -webkit-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075) !important;
  box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075) !important;
}
.single-element-container {
  display: inline;
}
</style>